export default __webpack_public_path__ + "static/media/STLTrading-windowclosureintimation.2895ae3e.pdf";